export const logoNavbar = {
  path: './assets/logo/by-bolago.png',
  alt: '',
  link: 'https://startuptools.org/se',
};
